import { ErrorFilledSVG, Icon } from "@newsela/angelou";

import {
  errorMessageIconCss,
  errorMessageCss,
  errorContainerCss,
} from "./AdminReportError.style";

interface AdminReportErrorProps {
  svgColor: string;
}
const AdminReportError = ({ svgColor }: AdminReportErrorProps) => {
  return (
    <div css={errorContainerCss}>
      <Icon
        SvgComponent={ErrorFilledSVG}
        __cssFor={{
          root: errorMessageIconCss(svgColor),
        }}
      />
      <div css={errorMessageCss}>
        Oops something went wrong, please refresh the page or try again later
      </div>
    </div>
  );
};

export default AdminReportError;
